export enum ArticleEditMode {
  VIDEO = 'video',
  NOTES = 'notes',
}
